import React, { useEffect, useState, useRef } from "react";
import ongoingService from "../../services/ongoingbooking";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import { toast } from "react-toastify";
const renderBookStatusBadge = (bookStatus) => {
  let badgeClass = "outlined-badge badge-purple";
  switch (bookStatus) {
    case "Success":
      badgeClass = "outlined-badge badge-green";
      break;
    case "Initiated":
      badgeClass = "outlined-badge badge-gray";
      break;
    case "Vendor Assigned":
      badgeClass = "outlined-badge badge-blue";
      break;
    case "Vendor Re-Assigned":
      badgeClass = "outlined-badge badge-yellow";
      break;
    case "Vendor Re-Quoted":
      badgeClass = "outlined-badge badge-purple";
      break;
    case "Re-Quote Accepted":
      badgeClass = "outlined-badge badge-blue";
      break;
    case "Cancelled":
      badgeClass = "outlined-badge badge-orange";
      break;
    case "Completed":
      badgeClass = "outlined-badge badge-indigo";
      break;
    default:
      badgeClass = "outlined-badge badge-gray";
  }
  return <span className={`badge  ${badgeClass}`}>{bookStatus}</span>;
};

const MyServices = () => {
  const [bookings, setBookings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [showReviewDetailsModal, setShowReviewDetailsModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);
  const [reviewDetails, setReviewDetails] = useState(null);
  useEffect(() => {
    fetchBookings();
  }, [fromDate, toDate]);

  const fetchBookings = async () => {
    try {
      const formData = {
        pageSize: 10,
        pageNo: 1,
        sParam: searchTerm,
        bookStatus: "",
        fromDate,
        toDate,
      };
      const response = await ongoingService.completeServicesBooking(formData);
      if (response.data.isSuccess) {
        setBookings(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching bookings", error);
    }
  };
  const fetchReviewDetails = async (bookingGuid) => {
    try {
      const response = await ongoingService.reviewbookingDetails(bookingGuid);
      if (response.data.isSuccess) {
        setReviewDetails(response.data.result);
      }
    } catch (error) {
      console.error("Failed to fetch review details", error);
    }
  };
  const handleViewReviewDetails = async (booking) => {
    setSelectedBooking(booking);
    await fetchReviewDetails(booking.bookingGuid);
    setShowReviewDetailsModal(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleStarClick = (value) => {
    setRating(value);
  };

  const handleShowModal = (booking) => {
    setSelectedBooking(booking);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setRating(0);
    setHoverRating(0);
    setReviewText("");
  };

  const handleSubmitReview = async () => {
    if (!rating || !reviewText) {
      toast.error("Please provide both rating and review text.");
      return;
    }

    const formData = {
      bookingGuid: selectedBooking?.bookingGuid,
      rating: rating,
      review: reviewText,
    };

    try {
      const response = await ongoingService.reviewServicesBooking(formData);
      if (response.data.isSuccess) {
        toast.success("Review submitted successfully!");
        handleCloseModal();
      } else {
        toast.error("Failed to submit review. Try again later.");
      }
    } catch (error) {
      console.error("Review submission failed:", error);
      toast.error("Something went wrong while submitting review.");
    }
  };
  const handleSearchClick = () => {
    setSearchTerm(searchInput);
  };
  useEffect(() => {
    if (searchTerm !== "") {
      fetchBookings();
    }
  }, [searchTerm]);

  return (
    <div>
      <div>
        <h3>Completed Bookings Detalis</h3>
      </div>
      <div className="filter-row">
        <div className="mt-3">
          <Flatpickr
            id="fromDate"
            className="date-filters"
            placeholder="Select From Date"
            value={fromDate}
            onChange={([date]) => setFromDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <Flatpickr
            id="toDate"
            className="date-filters"
            placeholder="Select To Date"
            value={toDate}
            onChange={([date]) => setToDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <div className="search-input">
            <input
              type="text"
              id="search"
              className="date-filters"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search...."
              ref={searchInputRef}
            />
          </div>
        </div>
        <div className=" mt-3">
          <div className="">
            <button
              className="date-filters btn orange-btn text-white"
              onClick={handleSearchClick}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 gap-4">
          {bookings.length === 0 ? (
            <div className="text-center mt-4">
              <h6>No Complete bookings available.</h6>
            </div>
          ) : (
            bookings.map((booking, index) => (
              <div
                key={booking.id}
                className="ongoning-details-card rounded-lg p-4 border mt-3"
              >
                <div className="ongoing-status flex justify-between items-center mb-2">
                  <h6 className="booking-details">
                    {booking.bookingNo} | {formatDate(booking.bookedOn)}
                  </h6>
                  <div>{renderBookStatusBadge(booking.bookStatus)}</div>
                </div>
                <div className="mb-1">
                  <h5>{booking.serviceName}</h5>
                </div>
                <div className="user-details mb-1">
                  Vendor - {booking.vendorName || "N/A"}, PhoneNo -{" "}
                  {booking.vendorPhoneNo ? (
                    <a href={`tel:${booking.vendorPhoneNo}`}>
                      {booking.vendorPhoneNo}
                    </a>
                  ) : (
                    "N/A"
                  )}
                  , Email -{" "}
                  {booking.vendorEmailAddress ? (
                    <a href={`mailto:${booking.vendorEmailAddress}`}>
                      {booking.vendorEmailAddress}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </div>

                <div className="quoted-button gap-2">
                  {booking.bookStatus === "Completed" && (
                    <>
                      {!booking.rating ? (
                        <td className="p-2">
                          <Link
                            className="give-review"
                            onClick={() => handleShowModal(booking)}
                          >
                            Give Review
                          </Link>
                        </td>
                      ) : (
                        <div
                          className="d-flex align-items-center mb-2 cursor-pointer"
                          onClick={() => handleViewReviewDetails(booking)}
                          style={{ cursor: "pointer" }}
                        >
                          {[1, 2, 3, 4, 5].map((star) => (
                            <span
                              key={star}
                              className={`fs-4 me-1 ${
                                star <= booking.rating
                                  ? "text-warning"
                                  : "text-secondary"
                              }`}
                            >
                              ★
                            </span>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Give Your Review</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <label className="form-label mb-4">Click the rate:</label>
          <div className="d-flex mb-3">
            {[1, 2, 3, 4, 5].map((star, index) => (
              <span
                key={index}
                className={`review-star fs-1 mx-4 cursor-pointer ${
                  index + 1 <= (hoverRating || rating)
                    ? "text-warning"
                    : "text-secondary"
                }`}
                style={{ fontSize: "100px", width: "100px", height: "100px" }}
                onClick={() => handleStarClick(index + 1)}
                onMouseEnter={() => setHoverRating(index + 1)}
                onMouseLeave={() => setHoverRating(0)}
              >
                ★
              </span>
            ))}
          </div>

          <label className="form-label">
            What are the main reasons for your rating?
          </label>
          <textarea
            className="form-control mb-3"
            rows="4"
            placeholder="Write your review..."
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
          ></textarea>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn black-btn" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button className="btn orange-btn" onClick={handleSubmitReview}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showReviewDetailsModal}
        onHide={() => setShowReviewDetailsModal(false)}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reviewDetails ? (
            <div className="p-3">
              {/* Rating */}
              <div className="mb-4 d-flex justify-content-center">
                <div>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      style={{ fontSize: "50px" }}
                      className={`mb-4 me-1 ${
                        star <= reviewDetails.rating
                          ? "text-warning"
                          : "text-secondary"
                      }`}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <></>
              </div>

              <div className="mb-4">
                <strong className="d-block mb-2">Comments:</strong>
                <div className="border p-3 rounded bg-light">
                  {reviewDetails.comments ? (
                    <p className="mb-0">{reviewDetails.comments}</p>
                  ) : (
                    <em className="text-muted">No comments provided.</em>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-3">Loading review details...</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="btn black-btn"
            onClick={() => setShowReviewDetailsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MyServices;
